import { Font, StyleSheet } from '@react-pdf/renderer';
Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  titleText: {
    fontWeight: 700,
    fontSize: 24,
    fontFamily: 'Lato',
    marginLeft: 53,
    marginRight: 53,
  },
  regularText: {
    fontWeight: 300,
    fontSize: 11,
    fontFamily: 'Lato',
  },
  smallText: {
    fontWeight: 400,
    fontSize: 9,
    fontFamily: 'Lato',
  },

  testimonialsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 53,
    marginRight: 53,
    marginBottom: 20,
    gap: 5,
  },
  testimonialsColumn: {
    width: '32%',
    flexDirection: 'column',
    display: 'flex',
  },
  testimonialItem: {
    border: '2px solid #000',
    borderRadius: 4,
    padding: 10,
    boxSizing: 'border-box',
    marginBottom: 10,
  },
  citationText: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 11,
    marginBottom: 5,
  },

  ticketsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 10,
    marginLeft: 53,
    marginRight: 53,
    marginBottom: 20,
  },
  ticketItem: {
    width: '22%',
    height: 'auto',
    border: '2px solid #EEEEEE',
    borderRadius: 5,
    boxSizing: 'border-box',
  },
  textWrapper: {
    padding: 10,
    textAlign: 'center',
  },

  ticketName: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 11,
    marginBottom: 10,
  },
  ticketPrice: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 11,
    marginBottom: 8,
  },
  ticketDivider: {
    height: 5,
    width: '100%',
  },
  ticketButtonWrapper: {
    backgroundColor: '#27343d',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    padding: 10,
  },
  ticketButton: {
    backgroundColor: 'red',
    borderRadius: 3,
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 9,
    textAlign: 'center',
    textDecoration: 'none',

    width: '100%',
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
});
